import { useEffect, useState } from "react";

const CustomHeader = (props) => {
  const { column, text, alwaysIcon, showIconNextToText } = props; // Pobranie text z propsów
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    if (showIconNextToText) return;
    const updateHeader = () => {
      const colWidth = column.getActualWidth();
      setIsNarrow(colWidth < 90);
    };

    updateHeader();
    column.addEventListener("widthChanged", updateHeader);

    return () => {
      column.removeEventListener("widthChanged", updateHeader);
    };
  }, [column, showIconNextToText]);

  if (showIconNextToText) {
    return (
      <div className="custom-header" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <span className="header-text">{text}</span>
        <i className="fas fa-info-circle" style={{ flexShrink: 0 }}></i>
      </div>
    );
  }

  return (
    <div className="custom-header">
      {alwaysIcon || isNarrow ? (
        <i className="fas fa-info-circle"></i> // Ikona info
      ) : (
        <span className="header-text">{text}</span> // Dynamiczny tekst
      )}
    </div>
  );
};

export default CustomHeader;